import React from 'react';

export const useTruncate = (text, maxLength = 43) => {
  return React.useMemo(() => {
    if (!text) return "";
    return text.length > maxLength ? text.substring(0, maxLength - 3) + "..." : text;
  }, [text, maxLength]);
};
